export function insertIf(condition, ...elements) {
  return condition ? (elements.length > 0 ? elements : [condition]) : [];
}
